import { useQuery } from '@biletiniz/apollo';
import { WALLET_HISTORY } from './gql/wallet-history';

export const useWalletHistory = () => {
  // TODO add pagination
  const { data, loading, error } = useQuery(WALLET_HISTORY, {
    variables: {
      skipPages: 0,
      pageSize: 100,
    },
    fetchPolicy: 'no-cache',
  });

  return {
    walletData: data?.walletHistory,
    error: error?.message,
    loading,
  };
};
